export default __webpack_public_path__ + "static/media/Mickey-Mouse-Skeleton-Key-Necklace.bb129b90.jpg";